<template>
  <create-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <div class="">
        <h5 class="dialogTitle margin-bottom-0">
          Chọn đơn vị ban hành đến
        </h5>
        <div class="select-Unit-BanHanh">
          <banhanh-department-tree
            :docId="docId"
            :selectedReceiverIds="
              receiversData ? receiversData.toDepartmentIds : null
            "
            :selectedHandlerIds="
              receiversData ? receiversData.toHandlerIds : null
            "
            ref="hanhanhDepartmentTree"
          ></banhanh-department-tree>
          <!-- department-tree:end -->
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__left form-button__action" slot="">
        <el-button class="dialogBtnPrimary" @click="save">
          Chọn
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fas fa-times-circle"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </create-dialog>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import BanhanhDepartmentTree from "./banhanh-department-tree";
import CreateDialog from "../../common/custom-dialog";
import h from "../../../services/h";

export default {
  name: "banhanh-select-receivers-dialog",
  props: ["isOpen", "docId", "receiversData"],
  mixins: [handleRequestErrorMixin],
  components: {
    CreateDialog,
    BanhanhDepartmentTree
  },

  methods: {
    save() {
      this.$emit("save", {receiversData: this.collectCheckedReceiversData()});
    },

    collectCheckedReceiversData() {
      let toDepartmentIds =
        h.collect(
          this.$refs.hanhanhDepartmentTree.getToDepartments(),
          item => item.id
        ) || [];
      // let toHandlerIds =
      //   h.collect(
      //     this.$refs.hanhanhDepartmentTree.getToHandlers(),
      //     item => item.id
      //   ) || [];
      let toHandlersData =
        h.collect(
          this.$refs.hanhanhDepartmentTree.getToHandlersData(),
          item => {
            return {
              userDeptRoleId: item.userDeptRole.id,
              vbStepInfoId: item.vbStepInfoId,
              stepId: item.stepId,
              flowId: item.flowId
            };
          }
        ) || [];
      return {
        toDepartmentIds: toDepartmentIds,
        // toHandlerIds: toHandlerIds,
        toHandlersData: toHandlersData
      };
    }
  }
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 200px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/banhanh-select-receivers-dialog.vue